// Scrollbar
import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"

// Mui
import { Table, TableBody, TableCell, TableHead, TableRow, useTheme } from "@mui/material"

// React Table
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from "react-table"

// Components
import HeaderSort from "../table-header-sort/index.jsx"

// -------------------------------------------------------|| REACT TABLE - COMPONENTS ||--------------------------------

const ReactTable = ({
  status,
  providers,
  data,
  columns,
  nextAction,
  pervAction,
  total,
  initialState,
  selectPage,
  dateFilter = false,
  customRows = false
}) => {
  // Use Theme
  const theme = useTheme()

  const tableInstance = useTable(
    { columns, data, initialState, manualPagination: true },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    pageOptions,
    page,
    setHiddenColumns,
    allColumns,
    state: { pageIndex, pageSize, globalFilter, hiddenColumns },
    preGlobalFilteredRows,
    setGlobalFilter,
    gotoPage,
    setPageSize
  } = tableInstance

  return (
    <>
      {/*<Stack direction="row" justifyContent="space-between" alignContent="center" p={2}>*/}
      {/*<GlobalFilter*/}
      {/*  status={status}*/}
      {/*  providerList={providers}*/}
      {/*  preGlobalFilteredRows={preGlobalFilteredRows}*/}
      {/*  globalFilter={globalFilter}*/}
      {/*  setGlobalFilter={setGlobalFilter}*/}
      {/*/>*/}
      {/*<HidingSelect*/}
      {/*  hiddenColumns={hiddenColumns}*/}
      {/*  setHiddenColumns={setHiddenColumns}*/}
      {/*  allColumns={allColumns}*/}
      {/*/>*/}
      {/*</Stack>*/}
      <SimpleBar timeout={600} sx={{ width: "100%", display: "block" }}>
        <Table {...getTableProps()}>
          <TableHead>
            {
              // Loop over the header rows
              headerGroups.map((headerGroup, index) => (
                // Apply the header row props
                <TableRow key={index} {...headerGroup.getHeaderGroupProps()}>
                  {
                    // Loop over the headers in each row
                    headerGroup.headers.map((column, index) => (
                      // Apply the header cell props
                      <TableCell
                        key={index}
                        sx={{
                          borderBottom: `solid 1px ${theme.palette.divider}`,
                          fontWeight: "bold",
                          textAlign: "center"
                        }}
                        {...column.getHeaderProps()}
                      >
                        <HeaderSort column={column} sort />
                      </TableCell>
                    ))
                  }
                </TableRow>
              ))
            }
          </TableHead>
          {/* Apply the table body props */}

          <TableBody
            {...getTableBodyProps()}
            sx={{
              ".MuiTableRow-root": {
                "&:nth-of-type(odd)": {
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.background.default
                      : customRows
                      ? theme.palette.grey[300]
                      : theme.palette.grey[50]
                },
                "&:nth-of-type(even)": {
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.background.default
                      : customRows
                      ? theme.palette.grey[400]
                      : theme.palette.grey[100]
                },
                "&:hover": {
                  backgroundColor:
                    theme.palette.mode === "dark" ? theme.palette.background.default : theme.palette.grey[100]
                }
              }
            }}
          >
            {dateFilter && (
              <>
                {headerGroups.map((group, i) => (
                  <TableRow key={i} {...group.getHeaderGroupProps()}>
                    {group.headers.map((column, index) => (
                      <TableCell key={index} {...column.getHeaderProps([{ className: column.className }])}>
                        {column.canFilter ? column.render("Filter") : null}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </>
            )}

            {page.map((row, i) => {
              prepareRow(row)
              return (
                <TableRow key={i} {...row.getRowProps()}>
                  {row.cells.map((cell, index) => {
                    return (
                      <TableCell key={index} {...cell.getCellProps()} sx={{ textAlign: "center", fontWeight: "bold" }}>
                        {cell.render("Cell")}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </SimpleBar>
    </>
  )
}

export default ReactTable
